<p>dialog-entry works!</p>
